import {Activity, ActivityType} from '../activity';
import {Definition} from '../definition';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class VerifyRequestActivity extends Activity {
  public Advanced: boolean;
  public ActivityExecutionCondition: string;
  public CheckForConflict: boolean;
  public ConflictFilter: string;
  public ConflictDenialMessage: string;
  public CheckForRequestConflict: boolean;
  public RequestConflictAdvancedFilter: string;
  public RequestConflictMatchCondition: string;
  public RequestConflictDenialMessage: string;
  public ConditionsTable: Definition[];

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.VerifyRequest);
    this._properties['Advanced'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['CheckForConflict'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ConflictFilter'] = ActivityPropertyDataType.STRING;
    this._properties['ConflictDenialMessage'] = ActivityPropertyDataType.STRING;
    this._properties['CheckForRequestConflict'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['RequestConflictAdvancedFilter'] = ActivityPropertyDataType.STRING;
    this._properties['RequestConflictMatchCondition'] = ActivityPropertyDataType.STRING;
    this._properties['RequestConflictDenialMessage'] = ActivityPropertyDataType.STRING;
    this._properties['ConditionsTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();

    if (this.CheckForConflict !== true) {
      this.ConflictFilter = null;
      this.ConflictDenialMessage = null;
    }

    if (this.CheckForRequestConflict !== true) {
      this.RequestConflictAdvancedFilter = null;
      this.RequestConflictMatchCondition = null;
      this.RequestConflictDenialMessage = null;
    }

    this.Advanced = !(
      this.ActivityExecutionCondition == null || this.ActivityExecutionCondition.trim() === ''
    );
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('verify-request', this.dialogConfig);
  }
}
